import React, {useRef, useState, useEffect} from 'react';
import {
  Grid,
  TextField, FormControl,MenuItem, Link
} from '@material-ui/core';
import {DeleteOutlined, Help} from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import SingleAutoComplete from "../../shared/SingleAutoComplete";
import {monthNames} from "../../../../helpers/utils";
import useAdminUserSession from "../../../../hooks/useAdminUserSession";
import CustomSnackbar from "../../../user/shared/CustomSnackbar";
import _ from "lodash";
import SingleAsyncAutoComplete from "../../shared/SingleAsyncAutoComplete";
import Tooltip from "@material-ui/core/Tooltip";
import GlobalSearchService from "../../services/GlobalSearchService";
import Time from "moment";

const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsRow: {
    marginBottom: '12px',
  }
}))

const HistoricalBlueprintFields = ({team, historicalBlueprint,handleNestedFieldChange, handleRemoveNestedFields,currentParentCompanyOptions,lastRow, handleOpenMaTransaction, ...props}) => {
  const classes = useStyles();
  const [snackBarMessage, setSnackBarMessage] = useState({show: false, message: '', severity: 'success'})
  const [formerlyRegistered, setFormerlyRegistered] = useState(historicalBlueprint.is_formerly_registered)
  const [didSelectPreviousCRD, setDidSelectPreviousCRD] = useState(false);
  const hasPreviousCRDBeenUpdatedRef = useRef(false);
  const [parentCrdKey, setParentCrdKey] = useState(Time.now())

  const {session} = useAdminUserSession();

  // Sync formerlyRegistered state when historicalBlueprint changes (e.g., after save)
  useEffect(() => {
    setFormerlyRegistered(historicalBlueprint.is_formerly_registered);
  }, [historicalBlueprint.is_formerly_registered, historicalBlueprint.ma_transaction_db_id]);

  const handleOnChangeAutocomplete = (field, selectedValue) => {
    handleNestedFieldChange('historical_blueprints', historicalBlueprint, field, selectedValue);
  }

  const resetValues = () => {
      handleOnChangeAutocomplete('previous_team_name', '');
      handleOnChangeAutocomplete('month', null);
      handleOnChangeAutocomplete('year', null);
      handleOnChangeAutocomplete('previous_parent_company_crd_id', null);

  }

  const handleFormerlyRegisteredChange = (value) => {
    setParentCrdKey(Time.now())
    setFormerlyRegistered(value.id);
    handleOnChangeAutocomplete('is_formerly_registered', value ? value.id : null)

    // Clear ma_transaction associations when changing to "No" (false)
    if (!value.id) {
      handleOnChangeAutocomplete('ma_transaction_display_id', null);
      handleOnChangeAutocomplete('ma_transaction_db_id', null);
    }

    resetValues();
  };

  function removeHistorical() {
    handleRemoveNestedFields(historicalBlueprint, 'historical_blueprints');
  }

  const handleOnChange = (event) => {
    event.persist();

    handleOnChangeAutocomplete(event.target.name, event.target.value)
  }

  const investors = (query) => {
    return GlobalSearchService.ria_investors(query, session)
  }

  const handleParentCompanyChange = (type, firm) => {
    let field = ''
    let field_name = ''
    switch (type) {
      case 'previous':
        field = 'previous_parent_company_crd_id'
        field_name = 'previous_parent_company_name'
        break;
      case 'current':
        field = 'current_parent_company_crd_id'
        break;
    }
    handleOnChangeAutocomplete(field, firm ? firm.id : null)
    handleOnChangeAutocomplete(field_name, firm ? firm.name : null)
  }

  const handlePreviousCRDChange = (value) => {
    setDidSelectPreviousCRD(true);
    const field = 'previous_parent_company_crd_id';
    const field_name = 'previous_parent_company_name';
    const field_team_name = 'previous_team_name';

    if (typeof value === 'string') {
      const trimmedValue = value.trim();
      const isNumericCRD = /^\d+$/.test(trimmedValue);
      const crdId = isNumericCRD ? Number(trimmedValue) : null;

      handleOnChangeAutocomplete(field, crdId);
      handleOnChangeAutocomplete(field_name, isNumericCRD ? trimmedValue : null);
    } else {
      handleOnChangeAutocomplete(field, value ? value.id : null);
      handleOnChangeAutocomplete(field_name, value ? value.name : null);
      if (value) {
        handleOnChangeAutocomplete(field_team_name, value ? value.only_name : null)
      }
    }
    hasPreviousCRDBeenUpdatedRef.current = true;
  };

  const handlePreviousCRDBlur = (e) => {
    if (hasPreviousCRDBeenUpdatedRef.current) {
      return;
    }

    if (!didSelectPreviousCRD && e.target.value?.trim()) {
      handlePreviousCRDChange(e.target.value.trim());
    }
    setDidSelectPreviousCRD(false);
  };

  const handlePreviousCRDFocus = () => {
    hasPreviousCRDBeenUpdatedRef.current = false;
  };

  const handleYearChange = (event) => {
    event.persist();
    handleOnChangeAutocomplete('year', event.target.value);
  };

  const handleMonthChange = (selectedValue) => {
    handleOnChangeAutocomplete('month', selectedValue.id);
  };


  const handleCloseSnackbar = () => {
    setSnackBarMessage({show: false, message: '', severity: 'success'})
  }
  const yearOptions = props.yearOptions || _.range(new Date().getFullYear(), 1949);
  const monthOptions = monthNames.slice(1).map((month, index) => ({
    id: index + 1,
    name: month
  }));

  const { id, _destroy } = historicalBlueprint;
  return (
      <React.Fragment>
        {_destroy ? null : (
            <Grid container spacing={2} key={id} className={classes.fieldsRow}>
              <Grid item container spacing={2} xs={10}>


                <Grid
                    item
                    xs={12}
                >
                  <div style={{ display: "flex", alignItems: "center", width: "100%", gap: "8px" }}>
                    <div style={{ flexGrow: 1 }}>
                      <SingleAutoComplete
                          options={[{id: true, name: "Yes"},{id: false, name: "No"}]}
                          handleOnChange={handleFormerlyRegisteredChange}
                          handleOnError={() => {}}
                          selectedId={formerlyRegistered}
                          field={'is_formerly_registered'}
                          label={"Firm was Formerly Registered"}
                          variant={"outlined"}
                          className="entity-autocomplete"
                          autoHighlight
                      />
                    </div>
                    {lastRow &&
                        <DeleteOutlined style={{marginTop: "16px"}} onClick={removeHistorical} />
                    }
                  </div>
                </Grid>
                { formerlyRegistered !== undefined &&
                    <>
                      <Grid item xs={3}>
                        <FormControl fullWidth>
                          <Tooltip
                            title={'Manually input former group name. If team name has not changed, manually input current name'}>
                          <Help className='help-tt-icon'/>
                        </Tooltip>
                          <TextField
                              label={formerlyRegistered ? 'Previous Name' : 'Previous Team Name'}
                              variant="outlined"
                              name='previous_team_name'
                              value={historicalBlueprint.previous_team_name || ''}
                              onChange={handleOnChange}
                              required={true}
                          />

                        </FormControl>
                      </Grid>

                      <Grid item xs={3}>
                        <FormControl fullWidth>
                          <Tooltip
                              title={<>Manually input the name the team currently goes by. Should be same as the name listed on the top of the profile under “Team Name”</>}>
                            <Help className='help-tt-icon'/>
                          </Tooltip>
                          <TextField
                              label="Current Team Name"
                              variant="outlined"
                              name='current_team_name'
                              value={ historicalBlueprint?.current_team_name || team.team_name || ''}
                              onChange={handleOnChange}
                          />

                        </FormControl>
                      </Grid>

                      <Grid item xs={3}>
                        <Tooltip
                            title={<>Select month of parent company switch from dropdown button if known</>}>
                          <Help className='help-tt-icon'/>
                        </Tooltip>
                        <SingleAutoComplete
                            options={monthOptions}
                            handleOnChange={(value) => handleMonthChange(value)}
                            handleOnError={() => {}}
                            selectedId={historicalBlueprint.month}
                            field={'month'}
                            label={"Month"}
                            variant={"outlined"}
                            className="entity-autocomplete"
                            autoHighlight
                        />
                      </Grid>

                      <Grid
                          item
                          xs={3}
                      >
                        <Tooltip
                            title={<>Select year of parent company switch from dropdown button</>}>
                          <Help className='help-tt-icon'/>
                        </Tooltip>
                        <TextField
                            select
                            fullWidth
                            value={historicalBlueprint.year || ''}
                            name='year'
                            onChange={handleYearChange}
                            label='Year'
                            variant='outlined'
                            required={true}
                        >
                          {yearOptions.map((year) => <MenuItem key={`start_year-${year}`} value={year}>{year}</MenuItem>)}
                        </TextField>
                      </Grid>


                      { !formerlyRegistered ?
                          <Grid item xs={3}>
                            <Tooltip
                                title={<>Select former parent company from the dropdown button</>}>
                              <Help className='help-tt-icon'/>
                            </Tooltip>
                            <SingleAsyncAutoComplete
                                fetch={investors}
                                handleOnChange={(value) => handleParentCompanyChange('previous',value)}
                                value={historicalBlueprint?.previous_parent_company_crd_id ?
                                    {id: historicalBlueprint?.previous_parent_company_crd_id, name: historicalBlueprint?.previous_parent_company_name} : ''}
                                field={'previous_parent_company_crd_id'}
                                label={"Previous Parent Company"}
                                required={true}
                                handleOnError={() => {}}
                            />

                          </Grid>
                          :
                          <Grid item xs={3} key={parentCrdKey}>
                              <Tooltip
                                  title={'Manually input team’s former CRD, which can be found on broker check'}>
                                <Help className='help-tt-icon'/>
                              </Tooltip>
                              <SingleAsyncAutoComplete
                                  fetch={investors}
                                  handleOnChange={(value) => handlePreviousCRDChange(value)}
                                  value={historicalBlueprint?.previous_parent_company_crd_id ?
                                      {id: historicalBlueprint?.previous_parent_company_crd_id,  name: historicalBlueprint.previous_parent_company_name || `${historicalBlueprint.previous_parent_company_crd_id}`} : ''}
                                  field={'previous_parent_company_crd_id'}
                                  label={"Previous CRD"}
                                  handleOnError={() => {}}
                                  onBlur={handlePreviousCRDBlur}
                                  onFocus={handlePreviousCRDFocus}
                                  required={true}
                              />
                          </Grid>
                      }

                      <Grid item xs={3}>
                        <Tooltip
                            title={<>Select current parent company from the dropdown button. Should be the EXACT same as the parent company listed at the top of the profile under “Parent Company”</>}>
                          <Help className='help-tt-icon'/>
                        </Tooltip>

                        <SingleAutoComplete
                            options={currentParentCompanyOptions}
                            handleOnChange={(value) => handleParentCompanyChange('current',value)}
                            handleOnError={() => {}}
                            selectedId={historicalBlueprint?.current_parent_company_crd_id || team.crd_id}
                            field={'current_parent_company_crd_id'}
                            label={"Current Parent Company"}
                            variant={"outlined"}
                            className="entity-autocomplete"
                            required={true}
                            autoHighlight
                        />

                      </Grid>

                      {formerlyRegistered && historicalBlueprint?.ma_transaction_db_id && (
                        <Grid item xs={3} style={{ display: 'flex', alignItems: 'center' }}>
                          <div>
                            <span>
                              M&A Transaction ID:{' '}
                            </span>
                            <Link
                              onClick={() => handleOpenMaTransaction(historicalBlueprint.ma_transaction_db_id)}
                              style={{ cursor: 'pointer' }}
                            >
                              M/A{historicalBlueprint.ma_transaction_db_id}
                            </Link>
                          </div>
                        </Grid>
                      )}
                    </>
                }

              </Grid>

              {snackBarMessage.show ?
                  <CustomSnackbar
                      open={snackBarMessage.show}
                      closeHandler={handleCloseSnackbar}
                      message={snackBarMessage.message}
                      options={{
                        severity: snackBarMessage.severity
                      }}
                  />
                  : null}
            </Grid>
        )}
      </React.Fragment>
  )
}

export default HistoricalBlueprintFields;
